export class VerificationRequestData {
  originalFile: File;
  signedDocument: File;
  reportType: string;

  constructor() {
  }
}
